import SvgIconFacebookCircle from '@/common/icons/generated/socials/IconFacebookCircle';
import SvgIconInstagramCircle from '@/common/icons/generated/socials/IconInstagramCircle';
import SvgIconLinkedinCircle from '@/common/icons/generated/socials/IconLinkedinCircle';
import SvgIconPinterestCircle from '@/common/icons/generated/socials/IconPinterestCircle';
import SvgIconTwitterCircle from '@/common/icons/generated/socials/IconTwitterCircle';

export const socials = [
  {
    url: 'https://www.facebook.com/displate',
    icon: SvgIconFacebookCircle,
  },
  {
    url: 'https://www.instagram.com/displate',
    icon: SvgIconInstagramCircle,
  },
  {
    url: 'https://twitter.com/displate',
    icon: SvgIconTwitterCircle,
  },
  {
    url: 'https://pinterest.com/displate',
    icon: SvgIconPinterestCircle,
  },
  {
    url: 'https://www.linkedin.com/company/displate.com',
    icon: SvgIconLinkedinCircle,
  },
];
